import * as yup from 'yup';
import 'yup-phone';

yup.addMethod(yup.array, 'services', (errorMessage) => {
  return yup.mixed().test('services', errorMessage, (value, schema) => {
    const { care_and_treatment_services, prevention_services, support_services, testing_services } = schema.parent
    const combined = care_and_treatment_services.concat(prevention_services).concat(support_services).concat(testing_services);

    return combined.length > 0;
  });
});

const phoneSchema = yup.string().phone('US');

export const validationSchema = yup.object().shape({
  'id': yup.string(),
  'organization_name_1': yup.string().required(),
  'organization_name_2': yup.string(),
  'organization_name_3': yup.string(),
  'program_name': yup.array().of(yup.string()),
  'address_country': yup.string().required(),
  'address_street1': yup.string().required(),
  'address_street2': yup.string().nullable(),
  'address_zip': yup.string().required(),
  'address_city': yup.string(),
  'address_county': yup.string(),
  'address_state': yup.string(),
  'phones': yup.array().of(yup.object().shape({
    'number': yup.string().phone('US').required(),
    'type': yup.string().required(),
    'ext': yup.number(),
    'note': yup.string(),
  })),
  'website_primary': yup.string().url(),
  'email': yup.string().email(),
  'website_facebook': yup.string().url(),
  'website_twitter': yup.string().url(),
  'website_linkedin': yup.string().url(),
  'website_instagram': yup.string().url(),
  'service_level': yup.string(),
  'primary_org_type': yup.string(),
  'legal_status': yup.string(),
  'status_501c3': yup.string(),
  'contact_pri_first_name': yup.string().required(),
  'contact_pri_last_name': yup.string().required(),
  'contact_pri_job_title': yup.string(),
  'contact_pri_email': yup.string().email().required(),
  'contact_pri_phone_number': yup.string().phone('US').required(),
  'contact_pri_phone_ext': yup.string(),
  'contact_pri_phone_note': yup.string(),
  'contact_sec_first_name': yup.string(),
  'contact_sec_last_name': yup.string(),
  'contact_sec_job_title': yup.string(),
  'contact_sec_email': yup.string().email(),
  'contact_sec_phone_number': yup.string().test('test-phone', 'Invalid format', (value) => {
    if (value) return phoneSchema.isValidSync(value);
    return true;
  }),
  'contact_sec_phone_ext': yup.string(),
  'contact_sec_phone_note': yup.string(),
  'support_services': yup.array().of(yup.string()).services('Please select at least one of the services listed.'),
  'prevention_services': yup.array().of(yup.string()).services('Please select at least one of the services listed.'),
  'testing_services': yup.array().of(yup.string()).services('Please select at least one of the services listed.'),
  'care_and_treatment_services': yup.array().of(yup.string()).services('Please select at least one of the services listed.'),
  'offer_self_testing': yup.string(),
  'audiences': yup.array().of(yup.string()).min(1),
  'languages': yup.array().of(yup.string()).min(1),
  'appointment_required': yup.bool(),
  'eligibility': yup.string(),
  'contact_hours': yup.bool().required(),
  'hours_sunday_from': yup.string(),
  'hours_sunday_to': yup.string(),
  'hours_monday_from': yup.string(),
  'hours_monday_to': yup.string(),
  'hours_tuesday_from': yup.string(),
  'hours_tuesday_to': yup.string(),
  'hours_wednesday_from': yup.string(),
  'hours_wednesday_to': yup.string(),
  'hours_thursday_from': yup.string(),
  'hours_thursday_to': yup.string(),
  'hours_friday_from': yup.string(),
  'hours_friday_to': yup.string(),
  'hours_saturday_from': yup.string(),
  'hours_saturday_to': yup.string(),
  'hours_comment': yup.string(),
  'fees': yup.array().of(yup.string()).min(1),
  'token': yup.string().required(),

  'info_status': yup.string(),
  'info_first_name': yup.string().when('id', {
    is: (id) => (id && id.length > 0),
    then: yup.string().required(),
  }),
  'info_last_name': yup.string().when('id', {
    is: (id) => (id && id.length > 0),
    then: yup.string().required(),
  }),
  'info_initial': yup.string(),
  'info_job_title': yup.string(),
  'info_phone_area': yup.number().when('id', {
    is: (id) => (id && id.length > 0),
    then: yup.number().required(),
  }),
  'info_phone_number': yup.number().when('id', {
    is: (id) => (id && id.length > 0),
    then: yup.number().required(),
  }),
  'info_phone_ext': yup.number(),
  'info_email': yup.string().email().when('id', {
    is: (id) => (id && id.length > 0),
    then: yup.string().email().required(),
  }),
  'info_email_check': yup.string().oneOf([yup.ref('info_email'), null]).when('id', {
    is: (id) => (id && id.length > 0),
    then: yup.string().required(),
  }),
});
